export default "__VITE_ASSET__f$vcGTsi__"